import React from 'react';
import { IconInfo } from './BuilderUiIcons';
import './SingleIngredientMessage.css';

function SingleIngredientMessage({ bulkIngredientUrl }) {
  return (
    <div className="single-ingredient-message" role="status">
      <span className="message-icon" aria-hidden="true">
        <IconInfo className="message-icon-svg" size={22} />
      </span>
      <div className="message-stack">
        <h3 className="message-title">Looking for a single ingredient?</h3>
        <p className="message-text">
          Custom blends require at least 2 ingredients. If you&apos;d like to purchase a single
          ingredient, click below to browse our bulk ingredients.
        </p>
        <a
          href={bulkIngredientUrl || '/collections/bulk-ingredients'}
          className="builder-action"
        >
          Browse single ingredients →
        </a>
        <p className="message-hint">Or select another ingredient below to create your custom blend</p>
      </div>
    </div>
  );
}

export default SingleIngredientMessage;
